// @flow
import { Button, toastError, toastSuccess } from 'bench-internal-theme';
import { ClientIdContext } from 'bk-web-app';
// $FlowFixMe - TS file
import { SelectedDataEntriesConsumer } from 'general-ledger';
import React from 'react';
import { Mutation, type MutationFunction } from '@apollo/client/react/components';

import { CLEAR_JOURNAL_ENTRY_OUTSTANDING_COMMENTS } from './queries';
import type {
  ClearJournalEntryOutstandingCommentsVariables,
  ClearJournalEntryOutstandingCommentsResponse,
  DataEntry,
} from './types';

const showClearNotificationsCompletedToast = numChanged =>
  toastSuccess(
    'Clear notifications completed successfully',
    `${numChanged} ${
      numChanged === 1 ? 'notification was' : 'notifications were'
    } successfully cleared`,
  );

const showClearNotificationsErrorToast = error =>
  toastError(
    'Failed to clear notifications',
    `Sorry, we encountered and error. The error was: ${error.message}`,
  );

const handleClearNotifications = (
  clearJournalEntryCommentNotifications,
  clientId,
  journalEntryIdsBeingCleared,
) => {
  if (!journalEntryIdsBeingCleared.length) {
    return;
  }

  clearJournalEntryCommentNotifications({
    variables: {
      clientId,
      journalEntryIds: journalEntryIdsBeingCleared,
    },
  });
};

type FollowUpViewClearNotificationsButtonContainerProps = {
  availableDataEntriesWithOutstandingComments: Array<DataEntry>,
};

const FollowUpViewClearNotificationsButtonContainer = ({
  availableDataEntriesWithOutstandingComments,
}: FollowUpViewClearNotificationsButtonContainerProps) => (
  <ClientIdContext.Consumer>
    {clientId => (
      <SelectedDataEntriesConsumer>
        {({ clearSelectedDataEntryIds, selectedDataEntryIds }: any) => (
          <Mutation
            mutation={CLEAR_JOURNAL_ENTRY_OUTSTANDING_COMMENTS}
            onCompleted={() => {
              showClearNotificationsCompletedToast(selectedDataEntryIds.length);
              clearSelectedDataEntryIds();
            }}
            onError={showClearNotificationsErrorToast}
          >
            {(
              clearJournalEntryOutstandingComments: MutationFunction<
                ClearJournalEntryOutstandingCommentsResponse,
                ClearJournalEntryOutstandingCommentsVariables,
              >,
            ) => {
              const areDataEntriesSelected = !!selectedDataEntryIds.length;
              const journalEntryIdsBeingCleared = availableDataEntriesWithOutstandingComments
                .filter(dataEntry => selectedDataEntryIds.includes(dataEntry.id))
                .map(dataEntry => dataEntry.journalEntry.id);

              return (
                <Button
                  disabled={!areDataEntriesSelected}
                  data-heap-id="bulk-clear-notifications"
                  onClick={() =>
                    handleClearNotifications(
                      clearJournalEntryOutstandingComments,
                      clientId,
                      journalEntryIdsBeingCleared,
                    )
                  }
                  styleType="secondary"
                >
                  Clear Notifications
                </Button>
              );
            }}
          </Mutation>
        )}
      </SelectedDataEntriesConsumer>
    )}
  </ClientIdContext.Consumer>
);

export default FollowUpViewClearNotificationsButtonContainer;
